import {
  ComunicadoSistemaFormData,
  fimDoDia,
  inicioDoDia,
} from "@/validations/comunicado-sistema-validation-schema";
import { ComunicadoSistemaNivel, ComunicadoSistemaPayload } from "@/types/comunicado-sistema.type";

/**
 * Form → payload. A janela é por dia (o date picker é sem hora): início no
 * começo do dia, fim no fim do dia (inclusivo). Precisão de hora fica para
 * quando houver um picker de data+hora.
 */
export function toComunicadoPayload(data: ComunicadoSistemaFormData): ComunicadoSistemaPayload {
  return {
    titulo: data.titulo.trim(),
    resumo: data.resumo.trim(),
    conteudo: data.conteudo?.trim() || undefined,
    nivel: data.nivel as ComunicadoSistemaNivel,
    inicioEm: inicioDoDia(data.inicioEm).toISOString(),
    fimEm: data.fimEm ? fimDoDia(data.fimEm).toISOString() : undefined,
    alvos: [
      ...(data.cargos ?? []).map((valor) => ({ tipo: "CARGO" as const, valor })),
      ...(data.areas ?? []).map((valor) => ({ tipo: "AREA" as const, valor })),
    ],
  };
}
